import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";
import type { IState } from "@/store";
import type { ApiPathGetter } from "@upmind-automation/types";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath:
    (s, g, rS, { isAdminContext }): ApiPathGetter =>
    () => {
      const admin = "api/admin/templates/client_area/slots";
      const client = "api/templates/client_area/slots";
      const contextual = isAdminContext ? admin : client;
      return { client, admin, contextual };
    },
  listFunctionalities: () => {
    return "list_client_area_template_slots";
  },
  getFunctionalities: () => {
    return "get_client_area_template_slot";
  },
  withParam: () => () => {
    return ["category"].join();
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath().contextual,
        storeModule: DataModules.TEMPLATES_CLIENT_SLOTS
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
